var $ = require('jquery');

export class ExtranetNavigation {
  private jsBlock: string;
  private block: string;
  private dom = {
    '$el': null,
    '$menuSectionContainer': null,
    '$menuSections': null,
    '$menuLinks': null
  };


  constructor(selector) {
    this.block = selector;
    this.dom.$el = $('.' + this.block );
  }

  private _initListeners () {
    var self = this;

    this.dom.$menuSectionContainer = this.dom.$el.find('.' + this.block + '__section-contents');
    this.dom.$menuSections = this.dom.$el.find('.' + this.block + '__section-contents > div');
    this.dom.$menuLinks = this.dom.$el.find('.' + this.block + '__section-toggle');

    this.dom.$menuSectionContainer.show();

    /* When opening menu section, close other sections */
    this.dom.$menuSections.on('show.bs.collapse', (e) => {
      this.dom.$menuSectionContainer.find('.collapse').not('#' + e.currentTarget.id).collapse('hide');
    });

    /* When clicking anywhere outside of the currently opened menu section, close the menu section */
    $(document).on('click', (e) => {
      if(!$(e.target).closest('.' + this.block).length) {
        this.dom.$menuSections.collapse('hide');
      }
    });

    this.dom.$menuSections.on('shown.bs.collapse', (e) => {
       /* If menu sections has been opened almost at the same time, only last one will stay visible */
      this.dom.$menuSectionContainer.find('.collapse.in').not('#' + e.currentTarget.id).collapse('hide');
    });

    //clear button focus when mouse moves out
    this.dom.$menuLinks.on('mouseleave', function () {
      $(this).blur();
    });

  }


  public init () {
    if(!this.dom.$el.length) {
      return;
    }

    this._initListeners();
  }
}
